import { Button } from "@material-ui/core";
import { useStyles } from "./styles";
import React, { useState, useEffect } from "react";
import { IPlacedOrder, IProcessedOrdersDetails } from "../constants";
import { refundReasonObj, RefundReasons, refundDialogButton, RefundActionType, RefundType } from "./types";
import { InfoCard, IInfoCard } from "./InfoCard";
import EColourPanel from "../../../interfaces/EColourPanel";
import { ConfirmationModal } from "./ConfirmationModal"
import { useTranslation } from "react-i18next";
import { useHandleConfirmationModal } from "./useHandleConfirmationModal";
import { OrderStatus } from "../../../interfaces/EOrderStatus";
import { useDialogRouteStages } from "../../dialogRoutes/useDialogRouteStages";
import { IMultiDialogChildren } from "../../dialogRoutes/MultiDialogRoute";
import { dialogKeys, SPECIFIC_ITEMS_REFUND_URL } from "../../../const/URL.const";
import { useDialogClose } from "../../dialogRoutes/useDialogClose";
interface IIssueRefundDialog extends IMultiDialogChildren {
    setMessageOptions: (value: boolean) => void;
    placedOrder: IPlacedOrder;
    orderDetails: IProcessedOrdersDetails,
    refundReasons: refundReasonObj[];
    submitButton: refundDialogButton
    title: string,
    infoCard: IInfoCard | undefined;
    totalRefundedPrice?: number
}
export function IssueRefundDialog(props: IIssueRefundDialog) {
    const { goToNextStep, getProps, setProps } = useDialogRouteStages(props.history);
    useDialogClose(props);
    const { onClose, venueId, dialogKey, routePath } = props;
    const {
        orderDetails,
        placedOrder,
        refundReasons,
        title,
        submitButton,
        infoCard,
        totalRefundedPrice } = getProps(dialogKey);

    const classes = useStyles();
    const { t } = useTranslation();
    const { setIsOpen, isOpen } = useHandleConfirmationModal();
    const [selectedReason, setSelectedReason] = useState<undefined | refundReasonObj>(undefined)
    const { color, Icon, label, labelColor } = submitButton ?? {};
    const [refundType, setRefundType] = useState<RefundType | undefined>(undefined);
    const isRefund = placedOrder?.placed_order_order_status === OrderStatus.FINISHED || placedOrder?.placed_order_order_status === OrderStatus.PARTIALLY_REFUNDED;
    const refundActionType = isRefund ? RefundActionType.REFUND : RefundActionType.DECLINE
    const showInfoCard = selectedReason?.hasInfo || !isRefund

    useEffect(() => {
        if (refundType) {
            setProps(dialogKeys.ORDER, "refundType", refundType);
        }
        if (selectedReason) {
            setProps(dialogKeys.ORDER, "reason", selectedReason.key);
        }
        // eslint-disable-next-line    
    }, [refundType, selectedReason])

    function onSubmit({ key }: refundReasonObj) {
        switch (key) {
            case RefundReasons.DISSATISFACTION:
            case RefundReasons.OTHER:
                setRefundType(isRefund ? RefundType.ITEMISED : RefundType.FULL)
                setIsOpen(true);
                break;
            case RefundReasons.REFUNDENTIRE:
                setRefundType(RefundType.FULL)
                setIsOpen(true);
                break;
            default:
                setRefundType(RefundType.ITEMISED)
                if (isRefund && key === RefundReasons.STOCK) {
                    setIsOpen(true);
                } else {
                    goToNextStep(dialogKeys.SPECIFICITEMSREFUND, {
                        ComponentProps: {
                            orderDetails: orderDetails,
                            placedOrder: placedOrder,
                            refundActionType: refundActionType,
                            isRefund: isRefund
                        },
                        isFormDialog: false,
                        dialogTitle: isRefund ? t("PartialReafund.OrderHistory.Void.DialogTitle"): t("order.dialog.DeclineOrder")
                    },
                        `${routePath}/${placedOrder.placed_order_id}${SPECIFIC_ITEMS_REFUND_URL}`,
                        dialogKey
                    )
                }
                break;
        }
    }
    return <>
        <section className={classes.issueRefundContainer}>
            <p>
                {title}
            </p>
            <ul>
                {
                    refundReasons && refundReasons?.map((reason: refundReasonObj) => {
                        return !reason.hide && <li onClick={() => setSelectedReason(reason)}
                            className={reason.key === selectedReason?.key ? classes.selected : undefined}
                        >
                            <p data-component-name="REFUND_REASON">{t(reason.title)}</p>
                            {reason.label && <div>
                                <p>{reason.label}</p>
                                <p data-component-name="REFUND_TOTAL_PRICE">{reason.totalPrice}</p>
                            </div>}
                        </li>
                    })
                }
            </ul>
            {infoCard && showInfoCard && <InfoCard title={infoCard.title} content={infoCard.content} />}
        </section>
        <footer className={classes.buttonsWrapper}>
            <Button
                style={{ padding: "0.9375rem 1.5625rem", backgroundColor: "#F3F4F9" }}
                variant={'contained'}
                disabled={false}
                onClick={onClose}
                data-component-name="FORM_CANCEL"
            >
                {(dialogKey===dialogKeys.PARTIALREFUNDREASONS && isRefund)? t('PartialReafund.Buttons.Back'):t('PartialReafund.Buttons.Cancel')}
            </Button>
            <Button
                style={{ padding: "0.9375rem 1.5625rem", backgroundColor: color && color, marginLeft: "1.25rem", color: labelColor && labelColor }}
                variant={'contained'}
                color={EColourPanel.PRIMARY}
                className={!selectedReason ? classes.Disabled : undefined}
                disabled={!selectedReason}
                onClick={() => selectedReason && onSubmit(selectedReason)}
                data-component-name="FORM_ONSUBMIT"
            >
                {label}
                {Icon && Icon}
            </Button>

        </footer>
        <ConfirmationModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            refundActionType={refundActionType}
            totalRefundedValue={totalRefundedPrice ?? placedOrder?.placed_order_order_total - placedOrder?.total_refund_amount}
            placedOrder={placedOrder}
            history={props.history}
            path={routePath}
            venueId={venueId}
        />

    </>
}
